import S from '@/service';

interface LessonDialog {
  visible: boolean;
  currentClass: any;
  lessonList: any;
}
interface RequestLessonParams {
  businessId: number;
  type: number;
  newDiyFlag: number;
}
const lessonDialog = {
  namespaced: true,
  state: {
    visible: false, // 讲次弹窗是否可见
    currentClass: {}, // 讲次相关班级
    lessonList: [], // 讲次列表
  },
  getters: {
    getVisible(state: LessonDialog) {
      return state.visible;
    },
    getCurrentClass(state: LessonDialog) {
      return state.currentClass;
    },
    getLessonList(state: LessonDialog) {
      return state.lessonList;
    },
  },
  mutations: {
    updateLessons(state: LessonDialog, data: any[]) {
      state.lessonList = data;
    },
    updateVisible(state: LessonDialog, data: boolean) {
      state.visible = data;
    },
    updateCurrentClass(state: LessonDialog, data: any) {
      state.currentClass = data;
    },
  },
  actions: {
    async getLessons({ commit }: any, params: RequestLessonParams) {
      await S.bk.getLessonList(params)
        .then((result: any) => {
          commit('updateLessons', result);
        });
    },
  },
};

export default lessonDialog;
